var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1093_1503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4434 16.5562H44.9785V9.23193C44.9785 6.80879 43.0071 4.8374 40.584 4.8374H5.23242C2.80928 4.8374 0.837891 6.80879 0.837891 9.23193V41.4585C0.837891 43.8816 2.80928 45.853 5.23242 45.853H46.4434C48.8665 45.853 50.8379 43.8816 50.8379 41.4585V20.9507C50.8379 18.5275 48.8665 16.5562 46.4434 16.5562ZM3.76758 9.23193C3.76758 8.42422 4.42471 7.76709 5.23242 7.76709H40.584C41.3917 7.76709 42.0488 8.42422 42.0488 9.23193V16.5562H5.23242C4.42471 16.5562 3.76758 15.899 3.76758 15.0913V9.23193ZM47.9082 41.4585C47.9082 42.2662 47.2511 42.9233 46.4434 42.9233H5.23242C4.42471 42.9233 3.76758 42.2662 3.76758 41.4585V19.2349C4.22588 19.3974 4.71904 19.4858 5.23242 19.4858H46.4434C47.2511 19.4858 47.9082 20.143 47.9082 20.9507V41.4585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16211 13.6265H37.6543C38.4633 13.6265 39.1191 12.9706 39.1191 12.1616C39.1191 11.3526 38.4633 10.6968 37.6543 10.6968H8.16211C7.35312 10.6968 6.69727 11.3526 6.69727 12.1616C6.69727 12.9706 7.35312 13.6265 8.16211 13.6265Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5137 37.064H34.7246C33.9156 37.064 33.2598 37.7198 33.2598 38.5288C33.2598 39.3378 33.9156 39.9937 34.7246 39.9937H43.5137C44.3227 39.9937 44.9785 39.3378 44.9785 38.5288C44.9785 37.7198 44.3227 37.064 43.5137 37.064Z",
    fill: "#3C3C3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1093_1503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.837891 0.345215)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.412ca376ff244a4cca7ae6608c016556.svg";
export { ForwardRef as ReactComponent };